import React, { cloneElement, useState } from "react";
import {
  List,
  CreateButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  EditButton,
  useResourceContext,
  useRecordContext,
  useGetOne,
  DateInput,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "react-responsive-modal";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Promotion Title" source="title" />
    <DateInput source="starts_at" label="Start date" />
    <DateInput source="ends_at" label="End date" />
  </Filter>
);

const textFieldStyle = {
  display: "block",
  width: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const ListActions = (props) => {
  const resource = useResourceContext();
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
  );

  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        <CreateButton basePath={resource} />
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const MyLayout = () => {
  const record = useRecordContext();
  const resource = useResourceContext();
  const { data } = useGetOne("promotions", { id: record?.id });
  console.log("props.....records", data); // works!
  return <EditButton resource={resource} record={data} />;
};

const PromotionNotificationList = (props) => {
  const record = useRecordContext();

  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          sort={{ field: "created_at", order: "DESC" }}
          filters={<Filters />}
          title="Promotion"
          actions={<ListActions props={props} />}
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <MyLayout />

            <TextField
              label="Promotion Title"
              source="title"
              style={textFieldStyle}
              allowEmpty
            />
            <DateField label="Start date" source="starts_at" showTime />
            <DateField label="End date" source="ends_at" showTime />
            <DateField source="created_at" showTime />
            <DateField source="updated_at" showTime />
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
    </>
  );
};

export default PromotionNotificationList;
